/**
 * The editor languages, in one place.
 *
 * The list used to live inline in PiChangeLanguageDialog while the storage key
 * was written there and read in Creator.tsx, so adding a language meant
 * editing a component. Both the settings dialog and the language dialog now
 * read from here.
 */
export interface EditorLanguage {
  /** i18next language code, also the translation file name. */
  short: string;
  /** Endonym, deliberately not translated: it names itself to its speaker. */
  full: string;
}

export const EDITOR_LANGUAGES: EditorLanguage[] = [
  { short: "en", full: "English" },
  { short: "nl", full: "Nederlands" },
  { short: "es", full: "Español" },
  { short: "fr", full: "Français" },
  { short: "de", full: "Deutsch" },
];

export const EDITOR_LANGUAGE_STORAGE_KEY = "editorLanguage";

/** The stored language, or the fallback when nothing is stored or it is unknown. */
export function resolveEditorLanguage(stored: string | null): string {
  const match = EDITOR_LANGUAGES.find((language) => language.short === stored);
  return match ? match.short : "en";
}
